import { Table as ANTDTable, TableProps } from 'antd';
import jp from 'antd/lib/locale/ja_JP';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { DEFAULT_PER_PAGE } from '~/constants/common';

interface IProps<RecordType> extends TableProps<RecordType> {}

const Table = ({
  locale,
  pagination,
  ...props
}: IProps<any>): React.ReactElement => {
  const { t } = useTranslation();

  return (
    <ANTDTable
      locale={
        locale || {
          ...jp.Table,
          filterEmptyText: t('common.empty-text'),
          emptyText: t('common.empty-text'),
        }
      }
      pagination={{
        showSizeChanger: false,
        pageSize: DEFAULT_PER_PAGE,
        position: ['bottomCenter'],
        ...pagination,
      }}
      {...props}
    />
  );
};

export default Table;
